import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevronDown",
  "use": "chevronDown-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevronDown\">\n<g clip-path=\"url(#chevronDown_clip0_1260_729)\">\n<path d=\"M12.59 4L8 8.58L3.41 4L2 5.41L8 11.41L14 5.41L12.59 4Z\" />\n</g>\n<defs>\n<clipPath id=\"chevronDown_clip0_1260_729\">\n<rect width=\"16\" height=\"16\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol